// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonImportDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.13686 5.99792 6.58542 2.27484 2.6883 4.52484 6.13686 5.99792ZM2.05335 1.25C3.41151 1.25 4.67136 2.02437 5.27993 3.02847L3.98755 3.77463C3.25388 2.50388 1.78364 1.83693.292554 1.83693.195114 1.83693.0976739 1.84061.00195312 1.84783.594045 1.46936 1.29848 1.25 2.05335 1.25Z" class="svg-bg"/>
  <path d="M.999997 5.43542 2 5.86257V8.99792H11V2.99792H8.00923L8.12971 1.99792H12V9.99792H.999997V5.43542ZM2 2.14354C2.51469 2.33801 2.98628 2.62393 3.3763 2.99792 3.24237 2.86952 3.09869 2.75151 2.94709 2.64401 2.67253 2.44932 2.37154 2.28914 2.05336 2.16427 2.03563 2.15731 2.01784 2.15028 2 2.14354Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.02708 9.00508L8.79352 4.06417L7.01977 5.00937C6.25432 3.64375 4.61058 2.55477 2.80075 2.49323C1.79483 2.45902 0.846189 2.71941 0.0400391 3.19691C0.16792 3.19163 0.297932 3.19115 0.427777 3.19556C2.41474 3.26313 4.34371 4.21851 5.26378 5.94511L3.49841 6.88584L8.02708 9.00508Z" class="svg-bg"/>
  <path d="M1.99841 7.84029L3.99841 8.77621V12.0041H13.9984V6.00414H10.0105L10.3207 4.00414H15.9984V14.0041H1.99841V7.84029Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9941 13.0046L11.7464 5.83383L9.34002 7.09725C8.3713 5.34926 6.28185 3.94813 3.97264 3.85543C2.68771 3.80384 1.47365 4.12909 0.439941 4.73285C0.603368 4.7271 0.76948 4.72751 0.93534 4.73416C3.47113 4.83597 5.92601 6.06956 7.0893 8.27896L4.66422 9.5522L10.9941 13.0046Z" class="svg-bg"/>
  <path d="M3.99994 11.4652V18.0048H20.9999V7.00479H13.6347L13.8445 5.00479H22.9999V20.0048H1.99994V10.3743L3.99994 11.4652ZM2.74423 5.00479C3.55333 5.21834 4.32085 5.5536 5.00185 6.00479 4.65813 5.77708 4.29232 5.57891 3.9103 5.411 3.53533 5.24619 3.14508 5.11055 2.74423 5.00479Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonImportDefault is a generated icon component.
 */
let IconCommonImportDefault = IconCommonImportDefault_1 = class IconCommonImportDefault extends IconBaseElement {
    render() {
        return html `${IconCommonImportDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonImportDefault.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonImportDefault = IconCommonImportDefault_1 = __decorate([
    customElement('zui-icon-common-import-default')
], IconCommonImportDefault);
export { IconCommonImportDefault };
